/** @jsxImportSource @emotion/react */
import { EuiFormRow, EuiTextArea } from "@elastic/eui";
import Label from "./Label";
import { css } from "@emotion/react";

function TextAreaField({
  field,
  handleOnChange,
  rows = 6,
  compressed = false,
  fullWidth = false,
  type = "text",
  width = null,
  showPlaceholder = true,
  helpText = null,
}) {
  const cssOptions = width ? `width: ${width}px` : "";
  return (
    <EuiFormRow
      label={<Label field={field} />}
      isInvalid={field.isInvalid}
      error={field.errors}
      isDisabled={field.disabled}
      fullWidth={fullWidth}
      display={compressed ? "rowCompressed" : "row"}
      helpText={helpText}
    >
      <EuiTextArea
        css={css(cssOptions)}
        compressed={compressed}
        rows={rows}
        fullWidth={fullWidth}
        value={field.value}
        placeholder={showPlaceholder ? field.label : ""}
        onChange={(e) => handleOnChange(e)}
        aria-label={field.label.toString()}
        name={field.name}
        isInvalid={field.isInvalid}
        type={type}
      />
    </EuiFormRow>
  );
}

export default TextAreaField;
